module.exports = ".container{\r\n    margin-top: 50px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Components/location/location.component.css
// module id = ./src/app/Components/location/location.component.css
// module chunks = main